import { FC } from "preact/compat";
import { useEffect } from "preact/hooks";
import { useBreakpoint, useLocalBool } from "~/hooks";
import TabItem from "./TabItem";
import { FloatingTabsProps } from "./interfaces";
import DragIcon from "@material-design-icons/svg/outlined/drag_indicator.svg";
import cn from "classnames";

const FloatingTabs: FC<FloatingTabsProps> = ({ id, items }) => {
    const bpMd = useBreakpoint("md");
    const defaultVisible = useLocalBool(`floating_tabs_visible_${id}`);

    useEffect(() => {
        const handleStaticTabs = (event: Event) => {
            if (!(event instanceof CustomEvent)) {
                return;
            }

            const { detail } = event;

            if (detail?.id === id) {
                const visible = detail?.visible;

                if (visible !== defaultVisible.peek()) {
                    defaultVisible.value = visible;
                }
            }
        };

        window.addEventListener("floating-menu.static-tabs", handleStaticTabs);

        return () => {
            window.removeEventListener(
                "floating-menu.static-tabs",
                handleStaticTabs,
            );
        };
    }, [defaultVisible, id]);

    if (!bpMd.value) {
        return null;
    }

    return (
        <div
            className={cn(
                "w-full border-b border-gray-200 h-[44px] min-h-[44px]",
                !defaultVisible.peek() && "hidden",
            )}
            data-floating-tabs
        >
            <div
                className="flex items-center grayscale h-full"
                data-floating-content
            >
                {items.map((item) => (
                    <TabItem key={item.link} item={item} id={id} />
                ))}
                <div
                    title="Move Tabs"
                    className="ml-4 cursor-grab p-1 text-gray-500 hover:text-sky-500"
                    data-floating-trigger
                >
                    <DragIcon
                        width="18"
                        height="18"
                        className="pointer-events-none fill-current"
                    />
                </div>
            </div>
        </div>
    );
};

export default FloatingTabs;
